{
  "zh-CN": {
    "filteredList": {
      "actions": {
        "showFilter": "Show Filters",
        "hideFilter": "Hide Filters"
      },
      "selected": "已选筛选条件",
      "remove": "移除 %{filter}",
      "more": "+%{count} 项",
      "groups": {
        "ship": "舰船",
        "capacity": "容量与尺寸",
        "price": "价格",
        "ownership": "拥有情况"
      }
    }
  }
}
